module.exports = __webpack_public_path__ + "assets/e06e1c1e074342ffede9621b146fa02f.png";